import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary-deep-blue text-white" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-135">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-136">
          {/* Organization Info */}
          <div data-id="element-137">
            <h3 className="text-xl font-playfair mb-4" data-id="element-138">Farasha Medical Aid</h3>
            <p className="font-inter text-sm mb-4" data-id="element-139">
              We redirect unused, unexpired medical supplies from U.S. hospitals
              to monastery clinics serving underserved Coptic communities in
              Egypt.
            </p>
            <p className="font-inter text-sm" data-id="element-140">
              501(c)(3) nonprofit organization
            </p>
          </div>
          {/* Quick Links */}
          <div data-id="element-141">
            <h3 className="text-xl font-playfair mb-4" data-id="element-142">Quick Links</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-143">
              <li data-id="element-144">
                <Link to="/" className="hover:underline" data-id="element-145">
                  Home
                </Link>
              </li>
              <li data-id="element-146">
                <Link to="/how-it-works" className="hover:underline" data-id="element-147">
                  How It Works
                </Link>
              </li>
              <li data-id="element-148">
                <Link to="/impact" className="hover:underline" data-id="element-149">
                  Impact
                </Link>
              </li>
              <li data-id="element-150">
                <Link to="/get-involved" className="hover:underline" data-id="element-151">
                  Get Involved
                </Link>
              </li>
              <li data-id="element-152">
                <Link to="/about" className="hover:underline" data-id="element-153">
                  About Us
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/donate" className="hover:underline" data-id="element-155">
                  Donate
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/coptic-people" className="hover:underline" data-id="element-157">
                  Coptic People
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-158">
            <h3 className="text-xl font-playfair mb-4" data-id="element-159">Legal & Transparency</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-160">
              <li data-id="element-161">
                <Link to="/privacy" className="hover:underline" data-id="element-162">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-163">
                <Link to="/terms" className="hover:underline" data-id="element-164">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-165">
                <Link to="/annual-report" className="hover:underline" data-id="element-166">
                  Annual Report
                </Link>
              </li>
              <li data-id="element-167">
                <Link to="/form-990" className="hover:underline" data-id="element-168">
                  Form 990
                </Link>
              </li>
              <li data-id="element-169">
                <Link to="/governance" className="hover:underline" data-id="element-170">
                  Governance Documents
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact & Newsletter */}
          <div data-id="element-171">
            <h3 className="text-xl font-playfair mb-4" data-id="element-172">Stay Connected</h3>
            <p className="font-inter text-sm mb-4" data-id="element-173">
              <a href="mailto:farashamedicalaid@gmail.com" className="hover:underline" data-id="element-174">
                farashamedicalaid@gmail.com
              </a>
            </p>
            <div className="flex space-x-4 mb-6" data-id="element-175">
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-176">
                <Facebook size={20} data-id="element-177" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-178">
                <Twitter size={20} data-id="element-179" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-180">
                <Instagram size={20} data-id="element-181" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-182">
                <Linkedin size={20} data-id="element-183" />
              </a>
              <a href="mailto:farashamedicalaid@gmail.com" className="text-white hover:text-primary-gold" data-id="element-184">
                <Mail size={20} data-id="element-185" />
              </a>
            </div>
            <h4 className="font-inter font-medium mb-2" data-id="element-186">
              Subscribe to our newsletter
            </h4>
            <form className="flex" data-id="element-187">
              <input type="email" placeholder="Your email" className="px-3 py-2 bg-white text-primary-deep-blue rounded-l-md w-full focus:outline-none" data-id="element-188" />
              <button type="submit" className="bg-primary-gold hover:bg-primary-royal-blue text-white px-4 py-2 rounded-r-md transition-colors" data-id="element-189">
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-8 text-sm font-inter text-center" data-id="element-190">
          <p data-id="element-191">
            © {new Date().getFullYear()} Farasha Medical Aid. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-192">
            Donations are tax-deductible to the extent allowed by law.
          </p>
        </div>
      </div>
    </footer>;
}